// AboutUs.jsx
import React, { useMemo } from 'react';
import style from './AboutUs.module.css';
import GearBig from '../../../images/GearBig.png';
import GearSmall from '../../../images/GearSmall.png';

// i18n
import { useParams } from 'react-router-dom';
import { getTranslation, normalizeLang } from '../../../helpers/translation';

const AboutUs = () => {
  const { lang: rawLang } = useParams(); // undefined на корені
  const lang = normalizeLang(rawLang); // 'en' якщо undefined
  const t = useMemo(() => getTranslation(lang), [lang]);

  const title = t.aboutUsSection?.aboutUsTitle || 'About Us';
  const description = t.aboutUsSection?.aboutUsDescription || '';

  // Розбиваємо опис на абзаци за подвійним перенесенням рядка
  const paragraphs = description
    .split(/\n{2,}/)
    .map(s => s.trim())
    .filter(Boolean);

  return (
    <div className={style.aboutUsContainer} id="about">
      <div className={style.headingGear}>
        <h1>{title}</h1>

        <div className={style.gearContainer} aria-hidden="true">
          <img
            src={GearBig}
            alt=""
            loading="lazy"
            decoding="async"
            className={style.gearBig}
            width="100"
            height="100"
          />
          <img
            src={GearSmall}
            alt=""
            loading="lazy"
            decoding="async"
            className={style.gearSmall}
            width="60"
            height="60"
          />
        </div>
      </div>

      <div className={style.paragraphContainer}>
        {paragraphs.length > 0 ? (
          paragraphs.map((p, i) => <p key={i}>{p}</p>)
        ) : (
          // Фолбек, якщо раптом немає перекладу
          <>
            <p>
              At <strong>Artemida Studio</strong>, we specialize in creating
              custom <strong>landing pages and corporate websites</strong> that
              help businesses establish a strong online presence. Our mission is
              to deliver modern, functional, and visually stunning solutions
              tailored to your brand&apos;s needs.
            </p>
            <p>
              By combining creativity, the latest technologies, and a
              personalized approach, we build websites that are not only
              aesthetically appealing but also fast, user-friendly, and fully
              responsive.
            </p>
            <p>
              Whether you need a high-converting <strong>landing page</strong>{' '}
              or a professional <strong>corporate website</strong>,{' '}
              <strong>Artemida Studio</strong> is here to bring your vision to
              life with high-quality, custom solutions.
            </p>
            <p>
              Choose professionalism and creativity – let’s build your perfect
              website together!
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default AboutUs;
